import * as React from 'react'
import { View, Text, TouchableOpacity } from 'react-native'
import styled from '@theme/styled-components'
import Theme from '@theme/Theme'

import Icon from '@components/icon/Icons'

import useI18n from '@i18n/useI18n'
import useBreakpoint from '@utils/useBreakpoints'
import useReducer from '@store/useReducer'
import * as SocieteStore from '@store/societe/societe'
import * as MetierStore from '@store/metier/metier'

interface Props {
  item: Partial<ControleForm>
  onClick: (item: Partial<ControleForm>) => void
  onDelete?: (id: string) => void
}

const DraftControleCard = ({ item, onClick, onDelete }: Props) => {
  const i18n = useI18n()
  const [, currentBreakpoint] = useBreakpoint()
  const isPhone = currentBreakpoint === 'phone'

  const services = useReducer(SocieteStore.store, (s) => s.services)
  const metiers = useReducer(MetierStore.store, (s) => s.metiers)

  const societe = services.find((s) => s.id === item.societeId)
  const metier = metiers.find((m) => m.id === item.metierId)

  return (
    <Item key={item.id} activeOpacity={0.9} onPress={() => onClick(item)}>
      <ItemBloc>
        <ItemTitle>{i18n.t('screens.controles.form.start.complete')}</ItemTitle>
        {!!item.nature && <Nature>{i18n.t(`screens.controles.form.nature.${item.nature}`)}</Nature>}

        {!!onDelete && !isPhone && (
          <Delete activeOpacity={0.9} onPress={() => onDelete(item.id || '')}>
            <Icon name="delete" size={24} color={Theme.colors.primary} />
          </Delete>
        )}
      </ItemBloc>

      <Separator />

      <ItemBloc>
        {!!metier && <Info>{metier.libelle}</Info>}
        {!!societe && <Info>{societe.nameSociete}</Info>}
        {!!item.creationDate && (
          <Info>{i18n.t('screens.controles.form.start.date', { date: new Date(item.creationDate) })}</Info>
        )}
      </ItemBloc>
    </Item>
  )
}

export default DraftControleCard

const Item = styled(TouchableOpacity)`
  background: ${(props) => props.theme.colors.background};
  border: 1px solid ${(props) => props.theme.colors.secondaryActive};
  border-radius: 6px;
  margin-bottom: 10px;
  position: relative;
  ${(props) => props.theme.breakpoint !== 'phone' && `height: 180px;`}
`

const ItemBloc = styled(View)`
  padding: 16px 24px;
  justify-content: center;
`

const ItemTitle = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
`

const Nature = styled(Text)`
  ${(props) => props.theme.fonts.Body};
  color: ${(props) => props.theme.colors.secondaryText};
`

const Info = styled(Text)`
  ${(props) => props.theme.fonts.Body};
  color: ${(props) => props.theme.colors.secondaryText};
  font-size: 14px;
`

const Separator = styled(View)`
  height: 1px;
  background-color: ${(props) => props.theme.colors.secondaryActive};
`

const Delete = styled(TouchableOpacity)`
  position: absolute;
  right: 20px;
  padding: 10px;
`
